export default {

  updateSocket(state, { status, ws }) {
    if(status === 'open'){
      state.socket = ws;
    }else if (status === 'closed') {
      state.socket = null;
    }
  },

  updateSnapShot(state, data) { //initialData, shutDown, automaticSaving
    state.eventLogs = data.allLogs;
    state.orders = data.orders;
    state.ledger = data.ledger;
    state.archive = data.archive;
    state.kpis = data.kpis;
    state.marketData = data.marketData;
    state.systemInfos = data.systemInfos
    state.futuresInfos = data.futuresInfos
    state.shortLedger = data.shortLedger;
    if (data.unMappedOrders) {
      state.unMappedManuals = data.unMappedOrders
    }
  },

  updateOrders(state, data) { //quando coloca ou cancela ordens
    state.orders = data.orders
    state.kpis = data.kpis
    state.marketData = data.marketData
  },

  processEvents(state, data) { //quando alguma ordem é preenchida e processada
    state.ledger = data.ledger;
    state.archive = data.archive;
    state.marketData = data.marketData;
    state.eventLogs = data.allLogs;
    state.orders = data.orders
    state.kpis = data.kpis
    state.shortLedger = data.shortLedger;
  },

  updateMarketData(state, data) {
    state.marketData = data.marketData
    state.kpis = data.kpis
  },

  updateSystemParams(state, data) {
    Object.assign(state.systemInfos.strategyParams, data.systemParams) //equivalente ao update do python, atualiza apenas os campos enviados sem sobrescrever o objeto inteiro
    state.kpis = data.kpis
  },

  updateManualOrdersMap(state, data) {
    state.unMappedManuals = data.unMappedOrders
  },

  updateTerminalState(state, data) {
    state.terminalOpenOrders = data.openOrders || []
    state.terminalCards = data.cards || []
    state.terminalError = data.error || ''
    if (data.balances) {
      state.terminalBalances = {
        BTC: data.balances.BTC ?? null,
        USDT: data.balances.USDT ?? null,
      }
    }
  },

  adjustFutures(state, data) {
    state.futuresInfos = data.futuresInfos
    state.kpis = data.kpis
  },

  setAggregationMode(state, mode) {
    state.aggregationMode = mode;
  },

  setAggregationOptions(state, options) {
    state.aggregationOptions = { ...state.aggregationOptions, ...options };
  },

};
